module.exports = __webpack_public_path__ + "static/media/placeTile.59e742c6.wav";